import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 14.6673V2.44508H4.05555V1.33398H5.22222V2.44508H10.7778V1.33398H11.9445V2.44508H14V14.6673H2ZM3.1111 13.5562H12.8889V6.5562H3.1111V13.5562ZM3.1111 5.4451H12.8889V3.5562H3.1111V5.4451Z",
		fill: "inherit"
	})
});
export default SvgCalendar;
